/* ============================================================
   ELEGANCE ANIMATIONS — Master Escala
   Scroll-triggered reveals + lazy image fade-in + tilt/parallax
   (agregado 2026-09-08 — ver elegance-custom.css "MOTION UPGRADE").
   ~4KB minimal, no dependencies.
   ============================================================ */

(function() {
  'use strict';

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function hasHover() {
    return window.matchMedia && window.matchMedia('(hover: hover)').matches;
  }

  // ---------- Scroll-triggered reveals ----------
  function initRevealObserver() {
    if (!('IntersectionObserver' in window)) {
      // Fallback: mostrar todo
      document.querySelectorAll('[data-elegance-reveal]').forEach(function(el) {
        el.classList.add('elegance-in-view');
      });
      return;
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('elegance-in-view');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.12,
      rootMargin: '0px 0px -50px 0px'
    });

    document.querySelectorAll('[data-elegance-reveal]').forEach(function(el) {
      observer.observe(el);
    });
  }

  // ---------- Lazy image fade-in ----------
  function initLazyImageFade() {
    var imgs = document.querySelectorAll('img[loading="lazy"]');
    imgs.forEach(function(img) {
      if (img.complete) {
        img.classList.add('is-loaded');
      } else {
        img.addEventListener('load', function() {
          img.classList.add('is-loaded');
        }, { once: true });
        img.addEventListener('error', function() {
          img.classList.add('is-loaded'); // mostrar broken icon en vez de fade infinito
        }, { once: true });
      }
    });
  }

  // ---------- Marquee duplication (para infinite scroll seamless) ----------
  function initMarquee() {
    var marquees = document.querySelectorAll('[data-elegance-marquee]');
    marquees.forEach(function(m) {
      var track = m.querySelector('[data-marquee-track]');
      if (!track || track.dataset.duplicated === '1') return;
      var clone = track.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.parentNode.appendChild(clone);
      track.dataset.duplicated = '1';
    });
  }

  // ---------- Tilt 3D con el mouse (tarjetas, imagen de producto) ----------
  function initTilt() {
    if (prefersReducedMotion() || !hasHover()) return;
    document.querySelectorAll('[data-elegance-tilt]').forEach(function(el) {
      if (el.dataset.tiltBound === '1') return; // evita listeners duplicados en re-init
      el.dataset.tiltBound = '1';

      el.addEventListener('mousemove', function(e) {
        var r = el.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width;  // 0..1
        var py = (e.clientY - r.top) / r.height;  // 0..1
        var tiltY = (px - 0.5) * 14;  // rotateY, ±7deg — contenido, no un tilt exagerado
        var tiltX = (0.5 - py) * 10;  // rotateX, ±5deg
        el.style.setProperty('--tiltX', tiltX.toFixed(2) + 'deg');
        el.style.setProperty('--tiltY', tiltY.toFixed(2) + 'deg');
        el.style.setProperty('--liftY', '-4px');
      }, { passive: true });

      el.addEventListener('mouseleave', function() {
        el.style.setProperty('--tiltX', '0deg');
        el.style.setProperty('--tiltY', '0deg');
        el.style.setProperty('--liftY', '0px');
      });
    });
  }

  // ---------- Parallax de mouse + scroll (fondo del hero) ----------
  var parallaxBound = false;
  function initParallax() {
    if (prefersReducedMotion()) return;
    var els = document.querySelectorAll('[data-elegance-parallax]');
    if (!els.length || parallaxBound) return;
    parallaxBound = true;

    var mouseX = 0, mouseY = 0, ticking = false;

    function apply() {
      var scrollY = window.scrollY || window.pageYOffset || 0;
      els.forEach(function(el) {
        var scrollShift = Math.min(scrollY * 0.06, 24); // parallax de scroll, tope 24px
        var x = mouseX * 8;                              // parallax de mouse, hasta ~8px
        var y = mouseY * 8 + scrollShift;
        el.style.setProperty('--parX', x.toFixed(1) + 'px');
        el.style.setProperty('--parY', y.toFixed(1) + 'px');
      });
      ticking = false;
    }

    if (hasHover()) {
      document.addEventListener('mousemove', function(e) {
        mouseX = (e.clientX / window.innerWidth) - 0.5;
        mouseY = (e.clientY / window.innerHeight) - 0.5;
        if (!ticking) { requestAnimationFrame(apply); ticking = true; }
      }, { passive: true });
    }

    document.addEventListener('scroll', function() {
      if (!ticking) { requestAnimationFrame(apply); ticking = true; }
    }, { passive: true });
  }

  // ---------- Boot ----------
  function init() {
    initRevealObserver();
    initLazyImageFade();
    initMarquee();
    initTilt();
    initParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init en navegación AJAX (themes con section rendering)
  document.addEventListener('shopify:section:load', init);
})();
